import * as React from 'react';

import { Alert, AlertTitle, Snackbar } from '@mui/material';

interface IAlerter {
  isError: boolean,
  message: string | null | undefined,
  title?: string | null,
  displayAlert: boolean,
  onClose?: () => void,
  vertical: 'top' | 'bottom',
  /**
   * in seconds
   * */
  autoHideTime?: number,
  horizontal: 'left' | 'center' | 'right',
}

function Alerter({
  isError,
  message,
  title,
  displayAlert,
  onClose,
  vertical,
  autoHideTime,
  horizontal,
}: IAlerter) {
  const [alertOpen, setAlertOpen] = React.useState(false);

  React.useEffect(() => {
    if (displayAlert) setAlertOpen(true);
    else setAlertOpen(false);
  }, [displayAlert]);

  const handleAlertClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOpen(false);
    window.history.replaceState({}, '');

    if (onClose) onClose();
  };
  const autoHide = () => {
    const time = autoHideTime ? autoHideTime * 1000 : 10000;
    return isError ? null : time;
  };
  return (
    <Snackbar
      open={alertOpen}
      autoHideDuration={autoHide()}
      onClose={handleAlertClose}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert
        severity={isError ? 'error' : 'success'}
        sx={{ width: '100%' }}
        elevation={12}
        onClose={handleAlertClose}
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </Snackbar>
  );
}

export default Alerter;
